import apiClient from '../../../../shared/api/apiClient';
import type { 
  FeePaymentResponseDto, 
  RecordCashPaymentDto, 
  FeePaymentReceiptDto,
  GetFeePaymentsDto,
  PaginatedFeePaymentResponseDto
} from '../types/fee-payment.dto';
import type { StudentFeeScheduleLineDto } from '../types/student-fees.dto';

export const getFeePayments = async (params?: GetFeePaymentsDto): Promise<PaginatedFeePaymentResponseDto> => {
  const { data } = await apiClient.get('/fee-payments', { params: params as Record<string, unknown> });
  return data;
};

export const getPaymentById = async (id: string): Promise<FeePaymentResponseDto> => {
  const { data } = await apiClient.get(`/fee-payments/${id}`);
  return data;
};

export const getStudentDues = async (studentId: string, params?: Record<string, unknown>): Promise<StudentFeeScheduleLineDto[]> => {
  const { data } = await apiClient.get(`/fee-payments/students/${studentId}/dues`, { params });
  if (Array.isArray(data)) return data;
  if (data && Array.isArray((data as any).data)) return (data as any).data;
  return [];
};

export const recordCashPayment = async (payload: RecordCashPaymentDto): Promise<FeePaymentResponseDto> => {
  const { data } = await apiClient.post('/fee-payments/cash', payload);
  return data;
};

export const getPaymentReceipt = async (id: string): Promise<FeePaymentReceiptDto> => {
  const { data } = await apiClient.get(`/fee-payments/${id}/receipt`);
  return data;
};

import { parseResponseToPdfBlob } from '../utils/generateFeeReceiptPDF';

export const downloadReceiptPdf = async (id: string): Promise<Blob> => {
  const cleanId = encodeURIComponent(id.trim());

  // Primary API: GET /api/student/fees/payments/{id}/receipt.pdf
  try {
    const { data } = await apiClient.get(`/api/student/fees/payments/${cleanId}/receipt.pdf`, {
      responseType: 'blob',
    });
    return await parseResponseToPdfBlob(data);
  } catch (err) {
    console.warn(`[downloadReceiptPdf] Failed /api/student/fees/payments/${id}/receipt.pdf:`, err);
  }

  // Fallback 1: GET /student/fees/payments/{id}/receipt.pdf
  try {
    const { data } = await apiClient.get(`/student/fees/payments/${cleanId}/receipt.pdf`, {
      responseType: 'blob',
    });
    return await parseResponseToPdfBlob(data);
  } catch (err) {
    console.warn(`[downloadReceiptPdf] Failed /student/fees/payments/${id}/receipt.pdf:`, err);
  }

  // Fallback 2: GET /api/fee-payments/{id}/receipt.pdf
  try {
    const { data } = await apiClient.get(`/api/fee-payments/${cleanId}/receipt.pdf`, {
      responseType: 'blob',
    });
    return await parseResponseToPdfBlob(data);
  } catch (err) {
    console.warn(`[downloadReceiptPdf] Failed /api/fee-payments/${id}/receipt.pdf:`, err);
  }

  // Fallback 3: GET /fee-payments/{id}/receipt.pdf
  const { data } = await apiClient.get(`/fee-payments/${cleanId}/receipt.pdf`, {
    responseType: 'blob',
  });
  return await parseResponseToPdfBlob(data);
};
